<template>
  <div v-if="loaded" class="ongoing">
    <div v-if="!ongoing.currentVisits || ongoing.currentVisits.length === 0">
      <h5 class="zero-bottom w3-animate-opacity w3-center w3-padding">
        <span class="flow-margin-left font-weight-bold w3-margin-top w3-text-deep-orange">
            <i class="fa fa-bullhorn"></i>
            {{ $t('notOngoing') }}
        </span>
      </h5>
    </div>

    <div v-else-if="ongoing && ongoing.currentVisits" class="ongoing-content" :class="{
      middle: openCard,
      'justify-center': isGroupVisit
    }">
      <div class="photo-part" :class="openCard ? 'hide' : ''">
        <div class="flow-padding-bottom zero-top flow-flex-col w3-right flex-align-end flex-1 flow-padding-left"
             v-if="imageBaseString">
          <img class="visitor-photo" :src="'data:image/png;base64,'+imageBaseString" alt="photo" draggable="false">
        </div>
      </div>

      <div class="middle-part">
        <h5 v-if="isGroupVisit" class="flow-main-color zero-bottom w3-animate-opacity w3-center">
          <i class="fa fa-users flow-green-active-color" aria-hidden="true" :title="$t('group')"
             style="display: inline-block">
          </i>
          <span class="font-weight-bold">
            <p style="display: inline-block; margin-left: 10px">{{
                $t("groupAppointment") + ": " + ongoing.currentVisits.length + " " + $t("persons")
              }}</p>
          </span><br>
          <span class="font-weight-normal">{{ ongoing.groupName }}
          </span>
        </h5>

        <h5 v-else class="flow-main-color zero-bottom w3-animate-opacity w3-center">
          <span class="font-weight-bold">
            <VisitorNameHeader :props-visitor="firstVisit.visitor"></VisitorNameHeader>
          </span><br>
          <span class="font-weight-normal">
            ({{ firstVisit.appointmentDateTime }}<span v-if="firstVisit.domainTypeName"> - {{
              firstVisit.domainTypeName
            }}</span>)
          </span>
          <span v-if="firstVisit.visitTicket"> - <b>{{
              $t('ticket')
            }} :</b>  {{ firstVisit.visitTicket }}</span>
          <br>
          <i class="fa fa-birthday-cake flow-green-active-color" aria-hidden="true" :title="$t('dob')">
          </i>
          <span class="flow-margin-left">{{
              firstVisit.visitor.dob ? firstVisit.visitor.dob : $t('notAvailable')
            }}</span>
        </h5>

        <!--Buttons-->
        <div>
          <button
            class="flow-btn w3-btn w3-border w3-ripple w3-round-medium w3-large w3-margin-top w3-margin-right w3-red"
            @click="endVisit">
            {{ $t('endVisit') }}
          </button>

<!--          <button-->
<!--            class="flow-btn w3-btn w3-border w3-ripple w3-round-medium w3-large w3-margin-top  flow-green-bg-active-color w3-text-white"-->
<!--            @click="">-->
<!--            {{ $t('endAndCallNext') }}-->
<!--          </button>-->
        </div>
      </div>

      <!--  Special action buttons-->
      <div v-if="!isGroupVisit" class="special-buttons" :class="openCard ? 'small hide' : ''">

        <div class="w3-margin-bottom">
          <div class="fa-stack cursor-pointer" :title="$t('recallVisitor')" @click.prevent="recallVisitor">
            <i class="fa fa-circle fa-stack-2x flow-blue-text"></i>
            <i class="fa fa-redo-alt fa-stack-1x fa-inverse"></i>
          </div>

          <div class="fa-stack  cursor-pointer" :title="$t('holdAppointment')" @click.prevent="holdAppointment(firstVisit.visitId, true)">
            <i class="fa fa-circle fa-stack-2x flow-blue-text"></i>
            <i class="fa fa-user-clock fa-stack-1x fa-inverse"></i>
          </div>

          <div class="fa-stack  cursor-pointer" :title="$t('markNoShow')" @click.prevent="noShowAppointment()">
            <i class="fa fa-circle fa-stack-2x flow-blue-text"></i>
            <i class="fa fa-user-times fa-stack-1x fa-inverse"></i>
          </div>
        </div>

        <div>
          <div class="fa-stack  cursor-pointer w3-disabled" :title="$t('nextAppointment')">
            <i class="fa fa-circle fa-stack-2x flow-blue-text"></i>
            <i class="fa fa-calendar-alt fa-stack-1x fa-inverse"></i>
          </div>

          <div class="fa-stack  cursor-pointer" :title="$t('forwardTo')" ref="domainButton"
               @click="() => this.showDomainBox = !this.showDomainBox">
            <i class="fa fa-circle fa-stack-2x flow-blue-text" :class="showDomainBox ? 'active' : ''"></i>
            <i class="fa fa-share fa-stack-1x fa-inverse"></i>
          </div>


          <div v-if="showDomainBox && !openCard" class="entry-box" ref="domainBox">
            <div class="w3-col w-100pc zero flow-margin-right sort-select">
              <flow-select class=" w3-border w3-round-medium" type="text"
                           :items="domainTypes"
                           :valueKey="'name'"
                           :valueKeyIndex="'id'"
                           :callback="(option) => {this.selectedDomain = option}">
              </flow-select>
            </div>
            <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-margin-right"
                    @click.prevent="changeDomain" :title="$t('save')">
              <i class="fa fa-check flow-green-active-color"/>
            </button>

            <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium"
                    @click.prevent="() => {
                      this.showDomainBox = false;
                      this.selectedDomain = null;
                    }" :title="$t('cancel')">
              <i class="fa fa-times w3-text-red"/>
            </button>
          </div>

          <!-- Comment button with the box -->
          <div class="fa-stack cursor-pointer" ref="commentButton" :title="$t('addComments')" @click="openCommentBox">
            <i class="fa fa-circle fa-stack-2x flow-blue-text" :class="showCommentBox ? 'active' : ''"></i>
            <i class="fa fa-comment fa-stack-1x fa-inverse"></i>
          </div>

          <div v-if="showCommentBox && !openCard" class="entry-box" ref="commentBox">
            <textarea
              v-model="commentText"
              class="comment-textarea"
              :placeholder="$t('visitorComment')"
            ></textarea>

            <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-margin-right"
                    @click.prevent="submitComment" :title="$t('save')">
              <i class="fa fa-check flow-green-active-color"/>
            </button>

            <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium"
                    @click.prevent="discardComment" :title="$t('cancel')">
              <i class="fa fa-times w3-text-red"/>
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div v-else class="w3-col w3-padding-large w3-center">
    <div>
      <h5 class="flow-main-color zero-bottom w3-animate-opacity w3-center">
        <span class="flow-margin-left font-weight-bold  w3-margin-top">
            {{ $t('loading') }}
        </span>
        <span class="zero">
          {{ $t('pleaseWait') }}
        </span>
      </h5>
    </div>
  </div>

</template>
<script>
import VisitorNameHeader from "../../common/VisitorNameHeader.vue";
import FlowSelect from "../../common/FlowSelect.vue";

export default {
  name: "OngoingVisit",
  components: {FlowSelect, VisitorNameHeader},
  props: ['ongoing', "endVisit", "holdAppointment", "recallVisitor", "noShowAppointment", "openCard"],
  data() {
    return {
      loaded: true,
      imageBaseString: null,
      showCommentBox: false,
      commentText: '',
      showDomainBox: false,
      selectedDomain: null,
      domainTypes: []
    }
  },
  computed: {
    firstVisit() {
      return this.ongoing?.currentVisits?.[0] || {};
    },
    isGroupVisit() {
      return this.ongoing?.currentVisits?.length > 1;
    }
  },
  mounted() {
    this.getPhotoContent();
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  watch: {
    ongoing(newV, oldV) {
      const isOldEmpty = !oldV || Object.keys(oldV).length === 0;
      const isNewNotEmpty = newV && Object.keys(newV).length > 0;

      if (isOldEmpty && isNewNotEmpty) {
        this.commentText = newV.currentVisits?.[0]?.visitor?.comment || '';
        this.getAllDomains();
      }

      this.imageBaseString = null;
      this.getPhotoContent();
    },
    openCard(newV) {
      if (newV === true) {
        this.showCommentBox = false;
      }
    }
  },
  methods: {
    getAllDomains() {
      let app = this;
      app.domainTypes = [];
      app.$restClient.domains.all().then(response => {
        let data = response.data;
        if (data.length > 0) {
          let dT = [];
          data.forEach(function (d) {
            if (d.service && app.firstVisit.domainTypeName !== d.type.name) dT.push(d.type);
          })
          this.$helper.sortByKey(dT, "name");
          app.domainTypes = dT;
        }
      }).catch(err => {
        console.log(err);
        app.$notify.notifyError({title: this.$t("failed")});
      })
    },
    openCommentBox() {
      if (this.showCommentBox) this.commentText = this.firstVisit.visitor.comment;
      this.showCommentBox = !this.showCommentBox;

    },
    submitComment() {
      this.showCommentBox = false
      const app = this;
      let visitor = app.firstVisit.visitor;
      visitor.comment = app.commentText;
      app.$restClient.visitors.updateVisitor(visitor).then(() => {
        app.$notify.notifySuccess({title: this.$t("success"), message: this.$t("modified-success")});
        app.$emit("refresh-visitor-list");
      }).catch(exception => {
        console.log(exception);
        app.$notify.notifyError({title: app.$t("failed")});
      })
    },
    discardComment() {
      this.showCommentBox = false
      this.commentText = this.firstVisit.visitor.comment;
    },
    changeDomain() {
      let visit = this.firstVisit;
      let payload = {
        visitId: visit.visitId,
        domainTypeId: this.selectedDomain.id,
      }

      this.showDomainBox = false;
      this.selectedDomain = null;
      this.$emit("forwardToDomain", payload);
    },
    handleClickOutside(event) {
      const outsideClick = (box, button) =>
        box && !box.contains(event.target) &&
        button && !button.contains(event.target);

      if (outsideClick(this.$refs.commentBox, this.$refs.commentButton)) {
        this.showCommentBox = false;
      }

      if (outsideClick(this.$refs.domainBox, this.$refs.domainButton)) {
        this.showDomainBox = false;
        this.selectedDomain = null;
      }
    },
    getPhotoContent() {
      if (Object.keys(this.ongoing).length > 0) {
        if (this.ongoing.currentVisits.length === 1) {
          let hexString = this.firstVisit.visitor.photoFile ? this.$helper.extractHexString(this.firstVisit.visitor.photoFile) : '';
          this.imageBaseString = hexString ? Buffer.from(hexString, 'hex').toString('base64') : '';
        }
      }
    },
  }
}

</script>

<style scoped>
.ongoing {
  min-height: 152px;
}

.ongoing-content {
  display: flex;
  width: 100%;
  align-items: flex-end;
  justify-content: space-between;
}

.ongoing .flow-btn {
  min-width: 200px;
}

.middle-part {
  padding: 0 10px;
}

.special-buttons div {
  font-size: 1.4em;
}

.special-buttons.small div {
  font-size: 1em;
}

.special-buttons .fa-circle {
  text-shadow: 3px 1px 2px gray;
  color: var(--flow-green-other-color);
}

.special-buttons .fa-stack:hover .fa-circle, .fa-circle.active {
  color: var(--flow-main-color);
}


.entry-box {
  margin-right: 5%;
  position: fixed;
  padding: 10px;
  background-color: var(--flow-main-color);
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  font-size: large !important;
  width: 230px;
}

.entry-box .flow-select-list-container {
  font-size: 0.8em;
}

.entry-box button.flow-btn {
  min-width: auto;
  margin-top: 5px;
}

.entry-box button.flow-btn:hover {
  background: #efe9e9;
}

.comment-textarea {
  width: 100%;
  height: 90px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  resize: none;
  box-sizing: border-box;
  outline: none;
}

.comment-textarea:focus {
  border-color: #d5e2e7;
  box-shadow: 0 0 0 2px rgb(173 173 173 / 20%);
}

@media screen and (max-width: 1048px) {

  .special-buttons div {
    font-size: 1.2em;
  }

  .entry-box {
    margin-right: 5%;
    position: fixed;
    padding: 10px;
    background-color: var(--flow-main-color);
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 9999;
    font-size: small !important;
    width: 180px;
  }

}

@media screen and (max-width: 1270px) {

  .ongoing-content.middle {
    justify-content: center;
  }

  .hide {
    display: none;
  }

}

</style>